import i18next from "i18next";
import React, { useContext } from "react";
import { User, List, Lock, Star } from "react-feather";
import { logoutUser, useUser } from "~/assets/js/Api/userApi";
import SimpleButton from "~/assets/js/components/Button/SimpleButton";
import { CustomerAreaContext } from "../../CustomerAreaProvider";
import NavigationItem from "./NavigationItem";

const Navigation = () => {
    const { dispatch } = useContext(CustomerAreaContext);
    const { user } = useUser();

    const isMember = Boolean(user?.membership_count);
    const navigationItems = [
        {
            title: "ordersOverview",
            icon: List,
            shouldRender: true,
            handleOnClick: () =>
                dispatch({ type: "CHANGE_PAGE", payload: "ordersOverview" }),
        },
        {
            title: "greenClubMember",
            icon: Star,
            shouldRender: isMember,
            handleOnClick: () => (window.location.href = user?.membership_url),
        },
        {
            title: "profile",
            icon: User,
            shouldRender: true,
            handleOnClick: () =>
                dispatch({ type: "CHANGE_PAGE", payload: "profile" }),
        },
        {
            title: "password",
            icon: Lock,
            shouldRender: true,
            handleOnClick: () =>
                dispatch({ type: "CHANGE_PAGE", payload: "password" }),
        },
    ];

    const handleLogout = () => {
        window.scrollTo(0, 0);
        logoutUser();
    };

    return (
        <div className="profile-navigation">
            {navigationItems.map((item, i) => {
                if (item.shouldRender) {
                    return (
                        <React.Fragment key={item.title}>
                            {i === 3 && <br />}
                            <NavigationItem
                                title={i18next.t(
                                    `customerArea.nav.${item.title}`
                                )}
                                icon={item.icon}
                                onClick={item.handleOnClick}
                                key={item.title}
                            />
                        </React.Fragment>
                    );
                }
            })}

            <div className="center-wrapper">
                <SimpleButton
                    customStyle="logout-btn"
                    onClick={handleLogout}
                    label={"customerArea.nav.logout"}
                />
            </div>
        </div>
    );
};

export default Navigation;
